
<template>
  <div class="attachment-button-header d-flex justify-content-center">
    <div class="d-flex flex-nowrap justify-content-between">
      <div class="d-flex flex-nowrap">
        <b-button v-for="(btn, index) in leftSideBtns" :key="'r-' + index" v-show="btn.render"
          v-b-tooltip.hover="{ customClass: 'custom-tooltip' }" :title="btn.title" @click="btn.onClick"
          :class="[{ 'action-button': true }, 'me-3']">
          <i :class="['las', 'la-lg', btn.icon]" />
        </b-button>
      </div>
      <div class="d-flex justify-content-end" style="right: 0px !important; position: absolute; margin-right: 8px;">
        <b-button v-if="isExpanded" @click="$emit('close-attachment')" :focusable="false" class="action-button">
          <i class="las la-times la-lg color-secondary"></i>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import printJS from "print-js";


export default {
  name: "attachment-button-header",
  props: {
    attachmentUrl: {
      type: String,
      required: false,
    },
    isExpanded: {
      type: Boolean,
      required: true,
      defualt: false,
    },
    isImage: {
      type: Boolean,
      default: false,
    },
    isXlsx: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    leftSideBtns() {
      return [
        {
          title: "Zoom Out",
          icon: "la-search-minus",
          onClick: () => this.$emit("zoom-out"),
          render: !this.isXlsx,
        },
        {
          title: "Zoom In",
          icon: "la-search-plus",
          onClick: () => this.$emit("zoom-in"),
          render: !this.isXlsx,
        },
        {
          title: "Print",
          icon: "la-print",
          onClick: this.isImage ? this.printImage : this.printPDF,
          render: !this.isXlsx,
        },
        {
          title: "Download File",
          icon: "la-file-download",
          onClick: () => this.$emit("download-attachment"),
          render: true,
        },
      ];
    },
  },
  methods: {
    printPDF() {
      fetch(this.attachmentUrl, { method: "GET" })
        .then((res) => {
          return res.blob();
        })
        .then((blob) => {
          printJS(URL.createObjectURL(blob));
        });
    },
    printImage() {
      fetch(this.attachmentUrl, { method: "GET" })
        .then((res) => {
          return res;
        })
        .then((res) => {
          printJS(res.url, 'image');
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import './attachmentButtonHeader.scss';
</style>
